import React from 'react';
import SafeIcon from '../../common/SafeIcon';

const Header = () => {
  const scrollToContact = () => {
    document.getElementById('contact-section')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header className="fixed top-0 inset-x-0 z-40 glass-panel border-b border-white/10">
      <div className="w-full max-w-[1440px] 2xl:max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-8 2xl:px-10 h-20 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center shadow-lg">
            <SafeIcon name="Layers" className="text-white w-4 h-4" />
          </div>
          <span className="font-semibold text-lg tracking-tight text-white">
            Websites by BPA Solutions
          </span>
        </div>
        <nav className="hidden lg:flex items-center gap-8 text-sm font-medium text-slate-300">
          <a href="#references" className="hover:text-white transition-colors">Website References</a>
          <a href="#systems" className="hover:text-white transition-colors">Systems Behind the Sites</a>
          <a href="#locations" className="hover:text-white transition-colors">Locations</a>
          <a href="#contact-section" className="hover:text-white transition-colors">Contact</a>
        </nav>
        <button
          onClick={scrollToContact}
          className="bg-white/10 hover:bg-white/20 text-white px-5 py-2.5 rounded-full text-sm font-medium transition-all shadow-sm border border-white/10 hover:border-white/20"
        >
          Request Similar
        </button>
      </div>
    </header>
  );
};

export default Header;